import { useTranslation } from '@eti/providers';
import { Stack } from '@etg/wings';
import SegmentPanel from './SegmentPanel';
import { jsx as _jsx } from "react/jsx-runtime";
const UnavailableSegment = () => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsx(Stack, {
    "data-testid": "unavailable-segment",
    children: /*#__PURE__*/_jsx(SegmentPanel, {
      content: t('Product.SeatMap.Segment.Unavailable.Content'),
      icons: [[{
        id: 'c_flat-seat-selected-blue',
        size: '32px'
      }, {
        id: 'ban',
        width: '31px',
        height: '19px',
        top: '4px'
      }]],
      title: t('Product.SeatMap.Segment.Unavailable.Title')
    })
  });
};
export default UnavailableSegment;
//# sourceMappingURL=UnavailableSegment.js.map